import { Helmet } from "react-helmet-async";
import { Box, Flex, Text } from "@chakra-ui/react";
import AuthLayout from "@/features/auth/auth-layout";
import SocialButtonGroup from "@/features/auth/social-buttons/social-button-group";
import SignInForm from "@/features/auth/sign-in/sign-in-form";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toTitle } from "@/utils/case";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function SignInPage() {
  const { t } = useTranslation();
  const { tTitle, tSentence } = useI18nHelper();
  const tail = (
    <Box fontSize={"12px"}>
      <Flex flexDirection={"column"} gap={"4px"} alignItems={"center"}>
        <Flex gap={"4px"}>
          <Text whiteSpace="nowrap">
            {tSentence("new_to_here", { ns: "auth" })}
          </Text>
          <Text whiteSpace="nowrap">
            {tSentence("sign_up_now", { ns: "auth" })}
          </Text>
        </Flex>
        <Flex gap={"4px"} alignItems={"center"}>
          <Link to={"/auth/sign-up"}>
            <Text as="u" fontWeight={"700"} whiteSpace={"nowrap"}>
              {tSentence("auth:sign_up", { ns: "auth" })}
            </Text>
          </Link>
          |
          <Link to={"/auth/forgot-password"}>
            <Text as="u" fontWeight={"700"} whiteSpace="nowrap">
              {tSentence("forgot_password")}
            </Text>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );

  return (
    <AuthLayout
      title={toTitle(t("sign_in", { ns: "auth" }))}
      tail={tail}
      // socialButtons={<SocialButtonGroup name={"sign in"} />}
    >
      <Helmet>
        <title>Pathrade | {t("sign_in", { ns: "auth" })}</title>
        <meta
          name="description"
          content={t("meta.description", { ns: "auth" })}
        />
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta
          property="og:title"
          content={t("meta.og.title", { ns: "auth" })}
        />
        <meta
          property="og:description"
          content={t("meta.description", { ns: "auth" })}
        />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      <SignInForm />
    </AuthLayout>
  );
}
